<header class="clsHeader">
  <app-navbar></app-navbar>
  <app-sections
    *ngIf="selectedSection"
    (sectionChange)="changeSelectedSection($event)"
    [selectedSection]="selectedSection"
  ></app-sections>
</header>
<div class="apps-container">
  <router-outlet></router-outlet>
</div>
